import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { TooltipModule, AccordionModule } from 'ngx-bootstrap';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';
import { SettingsPageComponent } from './settings-page.component';
import { SettingsActionsModalComponent } from './settings-actions-modal/settings-actions-modal.component';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.settings',
    url: '/settings',
    component: SettingsPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      accessMode: null
    }
  }
];

@NgModule({
  declarations: [SettingsPageComponent, SettingsActionsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    NgxSliderModule,
    PipesModule,
    EntityActivitiesModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [SettingsPageComponent, SettingsActionsModalComponent],
  entryComponents: [SettingsPageComponent, SettingsActionsModalComponent]
})
export class SettingsPageModule { }
